import PolicyAdmin from "./policies"
import { Consumer, Provider, PoliciesContext } from "./policies.context"

export { Consumer, Provider, PoliciesContext }
export { default as PoliciesPanel } from "./policies.panel"
export default PolicyAdmin
